<template>
  <div>
    <base-header class="pb-8 pt-4" />
    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col d-flex align-items-center">
              <h3 class="card-title mb-0">{{ $t("Toptan Ürünler") }}</h3>
              <div class="text-sm ml-4" style="width:200px;">
                <b-form-group class="mb-0">
                  <b-form-input placeholder="Ürün adı veya barkod" v-model="keyword" debounce="500"/>
                </b-form-group>
              </div>
            </div>
            <div class="col text-right">
              <b-button variant="warning" @click="$refs.showMyActiveOrders.show()">{{ myActiveOrders.length }}
              {{ $t("Adet Aktif Sipariş")}}</b-button>
              <b-button v-if="roles && roles.includes('superadmin')" @click="$refs.modal.show()" variant="primary">+
                {{ $t("Yeni Ekle") }}</b-button>
            </div>
          </div>
        </b-card-header>

        <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="getItems" responsive show-empty>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show>{{ $t("Henüz bir şey eklenmemiş") }}!</b-alert>
          </template>

          <template v-slot:cell(price)="data">
            {{ data.item.price }} TL
          </template>

          <template v-slot:cell(thumbnail)="data">
            <a href="#" class="text-underline" @click.prevent="openLightBox(data.item.images)">{{ $t("Görselleri Görüntüle") }}</a>
          </template>

          <template v-slot:cell(total)="data">
            {{ Math.ceil(data.item.total) }} TL
          </template>

          <template v-slot:cell(tax)="data">
            {{ data.item.tax }} %
          </template>

          <template v-slot:cell(stock)="data">
            <span v-if="data.item.stock === -1">{{ $t("Limitsiz") }}</span>
            <span v-else>{{ data.item.stock }}</span>
          </template>

          <template v-slot:cell(actions)="data">
            <b-button variant="warning" size="sm" @click="openOrderModal(data.item)">{{ $t("Sipariş Ver") }}</b-button>
            <b-button variant="info" size="sm" @click.prevent="editProduct(data.item)">{{ $t("Düzenle") }}</b-button>
            <b-button variant="danger" size="sm" @click.prevent="deleteAction(data.item.id)">{{ $t("Sil") }}</b-button>
          </template>

        </b-table>

        <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 14">
          <b-pagination v-model="pagination.currentPage" :total-rows="pagination.totalRows" :per-page="pagination.perPage" />
        </div>
      </b-card>
    </div>

    <b-modal ref="modal" title="Ürün Kaydı" @hide="resetModal">
      
      <b-form-group label="Ürün Resmi">
        <b-form-file
          v-model="upload_logo"
          @change="uploadLogo"
          accept="image/jpeg, image/png"
          multiple
        ></b-form-file>
        <ul v-if="product.images && product.images.length">
          <li v-for="(img, k) in product.images" :key="k"><a :href="img" target="_blank">{{ $t("Görsel") }} {{ k + 1 }}</a></li>
        </ul>
      </b-form-group>

      <b-row>
        <b-col>
          <b-form-group label="Başlık">
            <b-form-input v-model="product.name" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Barkod">
            <b-form-input v-model="product.barcode" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Birim">
            <b-form-select v-model="product.unit" :options="dependencies['units']" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__214__BV_label_">Stok <span style="font-size:12px">{{ $t("Limitsiz için") }} <b-badge variant="default">-1</b-badge> {{ $t("girin") }}</span></legend>
            <b-form-input v-model="product.stock" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Marka">
            <b-form-select v-model="product.brand_id" :options="dependencies['product-brands']" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Kategori">
            <b-form-select v-model="product.category_id" :options="dependencies['product-categories']" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Alış Fiyatı">
            <b-form-input v-model="product.purchase_price" type="number" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Satış Fiyatı">
            <b-form-input v-model="product.price" type="number"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="KDV Oranı">
            <b-form-input v-model="product.tax" type="number"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <label class="d-flex-align-items-center">
        <switches v-model="product.included_tax" theme="custom" color="red" />
        <span>{{ $t("Satış Fiyatına KDV Dahil") }}</span>
      </label>

      <template v-slot:modal-footer>
        <div class="text-right">
          <b-button variant="secondary" @click="resetAndHideModal">{{ $t("İptal") }}</b-button>
          <b-button variant="primary" @click="submitModal" :disabled="$v.$invalid">{{ $t("Kaydet") }}</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal ref="orderModal" title="Sipariş Oluştur">
      <b-form-group>
        <label>{{ $t("Adet") }}</label>
        <b-form-input type="number" v-model="order.piece" />
        <br>{{ order.piece * order.price }} TL
      </b-form-group>

      <b-form-group>
        <label>{{ $t("Not") }}</label>
        <b-form-textarea v-model="order.note" />
      </b-form-group>

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$refs.orderModal.hide()">{{ $t("İptal") }}</b-button>
          <b-button variant="primary" @click="submitOrder">{{ $t("Kaydet") }}</b-button>
      </template>
    </b-modal>

    <b-modal ref="showMyActiveOrders" title="Aktif Siparişlerim" size="xl">
      <b-table :fields="[
        { key: 'name', label: 'Ürün Adı' },
        { key: 'piece', label: 'Adet' },
        { key: 'price', label: 'Toplam Fiyat' },
        { key: 'note', label: 'Not' },
        { key: 'status', label: 'Durum' },
      ]" :items="myActiveOrders" bordered>
        <template v-slot:cell(name)="data">
          {{ data.item.product.name }} ({{ data.item.product.barcode }})
        </template>
        <template v-slot:cell(price)="data">
          {{ data.item.product ? data.item.product.total * data.item.piece : 'Ürün Silinmiş' }}
        </template>
      </b-table>
    </b-modal>

    <vue-easy-lightbox
    :visible="showLightBox"
    :imgs="media"
    @hide="closeLightBox"
  ></vue-easy-lightbox>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Switches from 'vue-switches'
  import { required } from 'vuelidate/lib/validators'

  export default {
    components: { Switches },
    validations: {
      product: {
        name: { required },
        price: { required },
        tax: { required },
      }
    },
    data () {
      return {
        showLightBox: false,
        media: [],
        order: {},
        keyword: '',
        upload_logo: null,
        myActiveOrders: [],
        submitType: 'create',
        dependencies: {},
        id: '',
        clients: [],
        brands: [],
        categories: [],
        product: {
          images: [],
          name: '',
          price: '',
          tax: 18,
          included_tax: true,
          rent_price: 0,
          purchase_price: 0,
        },
        pagination: {
          currentPage: 1,
          totalRows: 1,
          perPage: 15,
        },
        fields: [
          { key: 'thumbnail', label: 'Görsel' },
          { key: 'name', label: 'Başlık' },
          { key: 'barcode', label: 'Barkod' },
          // { key: 'purchase_price', label: 'Alış Fiyatı' },
          { key: 'price', label: 'Satış Fiyatı' },
          { key: 'tax', label: 'KDV Oranı' },
          { key: 'total', label: 'KDV Dahil' },
          { key: 'stock', label: 'Stok' },
          { key: 'actions', label: '', tdClass: 'text-right' },
        ],
      }
    },
    computed: {
      ...mapGetters(['roles'])
    },
    methods: {
      ...mapActions([
        'uploadPhoto',
        'getSuperProducts',
        'createSuperProduct',
        'updateSuperProduct',
        'deleteSuperProduct',
        'createSuperProductOrder',
      ]),
      openLightBox(images) {
        this.media = images.map(i => i.url);
        this.showLightBox = true;
      },
      closeLightBox() {
        this.showLightBox = false;
      },
      submitOrder() {
        this.createSuperProductOrder(this.order).then(response => {
          this.success(response.data.message);
        }).catch(error => {
          this.error(error.response.data.message);
        });
      },
      openOrderModal(product) {
        this.order = {
          piece: 1,
          super_product_id: product.id,
          price: Math.ceil(product.total),
        };
        this.$refs.orderModal.show();
      },
      submitModal () {
        if ( this.submitType === 'update' ) {
          this.updateSuperProduct({
            id: this.id,
            product: this.product,
          }).then(response => {
            this.success(response.data.message)
            this.hideModal()
            this.refreshTable()
          }).catch(error => {
            this.error(error.response.data.message)
          })
        } else {
          this.createSuperProduct(this.product)
            .then(response => {
              this.success(response.data.message)
              this.hideModal()
              this.refreshTable()
            }).catch(error => {
              this.error(error.response.data.message)
            })
        }
      },
      editProduct (product) {
        this.submitType = 'update'
        const item = JSON.parse(JSON.stringify(product))
        this.id = item.id
        this.product = item;
        this.openModal()
      },
      deleteAction (id) {
        this.$swal({
          icon: 'warning',
          title: 'Dikkat',
          text: 'Ürün kalici olarak silinecektir, emin misiniz?',
        }).then(ok => {
          if ( ok.value ) {
            this.deleteSuperProduct(id).then(response => {
              this.success(response.data.message)
              this.refreshTable()
            }).catch(error => {
              this.error(error.response.data.message)
            })
          }
        })
      },
      uploadLogo(e) {
        if( !this.product.images ) {
          this.product.images = [];
        }
        for(let i = 0; i < e.target.files.length; i++) {
          const formData = new FormData();
          formData.append("file", e.target.files[i]);
          this.uploadPhoto(formData).then(response => {
            this.product.images.push(response.data.file_url);
          });
        }
        this.upload_logo = null;
      },
      refreshTable () {
        this.$refs.table.refresh()
      },
      getItems () {
        const parameters = this.parameters()
        return this.getSuperProducts(parameters)
          .then(data => data.data).then(response => {
            const products = response.products;

            this.myActiveOrders = response.my_active_orders;
            this.dependencies = response.dependencies;

            this.pagination.totalRows = products.total
            return products.data;
          })
      },
      parameters(){
        const params = {}
        params.page = JSON.parse(JSON.stringify(this.pagination.currentPage))
        if( this.keyword.length > 0 ) {
          params.keyword = this.keyword;
        }
        return params;
      },
      resetAndHideModal () {
        this.resetModal()
        this.hideModal()
      },
      openModal() {
        this.$refs.modal.show()
      },
      hideModal() {
        this.$refs.modal.hide()
      },
      resetModal () {
        this.submitType = 'create'
        this.product = {
          images: [],
          title: '',
          price: '',
          tax: 18,
          included_tax: true,
        }
      },
    },
    watch: {
      keyword() {
        this.refreshTable();
      }
    }
  }
</script>
